import Hero from "./sections/Hero";
// import SearchSection from "./sections/SearchSection";
import PromiseSection from "./sections/PromiseSection";
import FeaturedDeals from "./sections/FeaturedDeals";
import FinancingSection from "./sections/FinancingSection";
import AboutSection from "./sections/AboutSection";

/**
 * Home Page Component
 *
 * This is the main landing page of the website.
 * It contains all the sections that make up the homepage.
 *
 * To add more pages:
 * 1. Create a new folder in src/pages/ (e.g., src/pages/Inventory/)
 * 2. Create an index.tsx file in that folder
 * 3. Add your page sections in a sections/ subfolder
 * 4. Import and use React Router in App.tsx for navigation
 */
export default function HomePage() {
  return (
    <main className="w-full overflow-x-hidden">
      {/* Hero Section with Video Background and Navigation */}
      <Hero />

      {/* Search Filters Section */}
      {/* <SearchSection /> */}

      {/* Our Promise Section */}
      <PromiseSection />

      {/* Featured Deals Section */}
      <FeaturedDeals />

      {/* Financing Section */}
      <FinancingSection />

      {/* About & Testimonials Section */}
      <AboutSection />
    </main>
  );
}
